import React from "react";
/* eslint-disable */
import {
  Box, TableHead, TableBody, TableCell, TableContainer, TableRow, Table
} from '@material-ui/core';
import moment from 'moment';

export default class ComponentToPrint extends React.Component {

  render() {
    const reportData = this.props.reportData;
    const data = this.props.searchData;
    const totalValues = this.props.totalValues;
    const getFillRate = this.props.getFillRate;

    return (
      <div style={{ padding: '10px' }}>
        <h3><center><u>SKU Wise Quantity Bought against Purchase Order</u></center></h3>
        <div>&nbsp;</div>

        <div>&nbsp;</div>
        <Box minWidth={1050}>
          <TableContainer style={{ marginLeft: '5px' }}>
            <Table aria-label="caption table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">Date</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">FCC</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Code</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="left">SKU Description</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Ordered Qty</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Supplied Qty</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">Fill Rate</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {reportData.map((row, index) => (
                  <TableRow key={index}>
                    <TableCell align="left">{moment(row.orderDate).format("YYYY-MM-DD")}</TableCell>
                    <TableCell align="left">{row.factoryName}</TableCell>
                    <TableCell align="left">{row.skuCode}</TableCell>
                    <TableCell align="left">{row.skuDescription}</TableCell>
                    <TableCell align="right">{row.orderedQty == 0 ? '-' : parseFloat(row.orderedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                    <TableCell align="right">{row.suppliedQty == 0 ? '-' : parseFloat(row.suppliedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                    <TableCell align="right">{getFillRate(row) == 0 ? '-' : parseFloat(getFillRate(row)).toFixed(2)}</TableCell>
                  </TableRow>
                ))}
                <TableRow>
                  <TableCell sx={{ fontWeight: "bold" }} colSpan={4}>Total</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalOrderedQty == 0 ? '-' : parseFloat(totalValues.totalOrderedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalSuppliedQty == 0 ? '-' : parseFloat(totalValues.totalSuppliedQty).toLocaleString('en-US', {minimumFractionDigits: 2, maximumFractionDigits: 2})}</TableCell>
                  <TableCell sx={{ fontWeight: "bold" }} align="right">{totalValues.totalFillRate == 0 ? '-' : parseFloat(totalValues.totalFillRate).toFixed(2)}</TableCell>
                  
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
      </div>
    );
  }
}
